import { useEffect } from 'react';

interface Props {
  ref: { current: HTMLElement | null };
  onResize(resizeObserverEntry: ResizeObserverEntry): void;
}

const useResizeObserver = ({ ref, onResize }: Props) => {
  useEffect(() => {
    if (!ref.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries.length > 0) {
        onResize(entries[0]);
      }
    });

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current, onResize]);
};

export default useResizeObserver;
